import type { PropsWithChildren } from 'react';

import { H3 } from '#/components/Text/H3';

type Props = {
  title: string;
  qaId: string;
};

export function ViewUserProfilePageContentSection({
  children,
  title,
  qaId,
}: PropsWithChildren<Props>) {
  return (
    <section data-qa-id={qaId}>
      <header>
        <H3>{title}</H3>
      </header>

      {children}
    </section>
  );
}
